import { forwardRef, useState, useEffect } from "react";

import {
    ALARM_PRIORITY, USER_VIEW
} from "../../common/constant/common-constants";

import { connect } from "react-redux";
import { alarmBackground, handleOutsideClick } from "../../common/utils/CommonUtils";
import BedCardDesktopView from "./BedCardDesktopView";
import BedCardMobileView from "./BedCardMobileView";


const BedCardVentilatorMonitor = forwardRef((props, ref) => {

    const [showMoreAlarms, setShowMoreAlarms] = useState(null)
    const [lastAlarm, setLastAlarm] = useState();
    const [showMoreVentilatorAlarms, setShowMoreVentilatorAlarms] = useState(false);

    useEffect(() => {

        if (props.alarmData && props.alarmData.length > 0) {
            let alarm = props.alarmData[0];

            let alarmClass = getAlarmPriorityClass(alarm);
            if (alarmClass === ALARM_PRIORITY.HIGH_PRIORITY &&
                (!lastAlarm || !(lastAlarm.name === alarm.name && lastAlarm.value === alarm.value))) {
                let snd = new Audio("https://media.geeksforgeeks.org/wp-content/uploads/20190531135120/beep.mp3");
                // snd.play();

                setLastAlarm(alarm);
            }
        }
    }, [props.alarmData]);


    useEffect(() => {
        if (props.ventilatorAlarmData && props.ventilatorAlarmData.length > 0) {
            let alarm = props.ventilatorAlarmData[0];

            let alarmClass = getAlarmPriorityClass(alarm);

            if (alarmClass === ALARM_PRIORITY.HIGH_PRIORITY &&
                (!lastAlarm || !(lastAlarm.name === alarm.name && lastAlarm.value === alarm.value))) {
                let snd = new Audio("https://media.geeksforgeeks.org/wp-content/uploads/20190531135120/beep.mp3");
                // snd.play();
                setLastAlarm(alarm);
            }
        }
    }, [props.ventilatorAlarmData]);

    const handleShowMoreAlarmsClick = (event) => {
        event.stopPropagation();
        setShowMoreAlarms(!showMoreAlarms);
        if (!showMoreAlarms) {
            handleOutsideClick(event, 'alarm-display-bar', setShowMoreAlarms);
        }
    }

    const handleShowMoreVentilatorAlarmsClick = (event) => {
        event.stopPropagation();
        setShowMoreVentilatorAlarms(!showMoreVentilatorAlarms);
        if (!showMoreVentilatorAlarms) {
            handleOutsideClick(event, 'alarm-display-bar', setShowMoreVentilatorAlarms);
        }
    }

    const getAlarmPriorityClass = (alarmData) => {

        // let id = bedId && bedId.toString();

        switch (alarmData.priority?.toLocaleUpperCase()) {
            case "HIGH":
                return ALARM_PRIORITY.HIGH_PRIORITY;
            case "MEDIUM":
                return ALARM_PRIORITY.MEDIUM_PRIORITY;
            case "LOW":
                return ALARM_PRIORITY.LOW_PRIORITY;
            default:
                return ALARM_PRIORITY.LOW_PRIORITY;
        }
    }


    const ventilatorConnected = props.ventilatorHeartbeat?.isConnected;
    const user_enabled = props?.ventilatorHeartbeat?.user_enabled
    const ventilationStatus = props.ventilatorStandby?.ventilationStatus;
    const monitorConnected = props?.monitorHeartBeatData?.isConnected

    return (
        <>
            {props.config.userView === USER_VIEW.DESKTOP && (
                <BedCardDesktopView
                    props={props}
                    refProp={props.myForwardedRef}
                    getAlarmPriorityClass={getAlarmPriorityClass}
                    handleShowMoreAlarmsClick={handleShowMoreAlarmsClick}
                    handleShowMoreVentilatorAlarmsClick={handleShowMoreVentilatorAlarmsClick}
                    showMoreAlarms={showMoreAlarms}
                    showMoreVentilatorAlarms={showMoreVentilatorAlarms}
                    ventilatorConnected={ventilatorConnected}
                    user_enabled={user_enabled}
                    ventilationStatus={ventilationStatus}
                    monitorConnected={monitorConnected}
                />
            )}

            {props.config.userView === USER_VIEW.MOBILE && (
                <BedCardMobileView
                    props={props}
                    refProp={props.myForwardedRef}
                    getAlarmPriorityClass={getAlarmPriorityClass}
                    handleShowMoreAlarmsClick={handleShowMoreAlarmsClick}
                    handleShowMoreVentilatorAlarmsClick={handleShowMoreVentilatorAlarmsClick}
                    showMoreAlarms={showMoreAlarms}
                    showMoreVentilatorAlarms={showMoreVentilatorAlarms}
                    ventilatorConnected={ventilatorConnected}
                    user_enabled={user_enabled}
                    ventilationStatus={ventilationStatus}
                    monitorConnected={monitorConnected}
                />
            )}
        </>
    );

})
const mapStateToProps = (state, ownProps) => {
    let bedDetails = state.bedDetailsReducer.bedDetails[ownProps.bedId];
    let ventilatorHeartbeat = state.deviceVitalDataReducer?.ventilatorHeartbeat?.[ownProps.bedId];
    let ventilatorStandby = state.deviceVitalDataReducer?.ventilatorStandby?.[ownProps.bedId];
    return {
        bedDetails: bedDetails,
        ventilatorHeartbeat: ventilatorHeartbeat,
        ventilatorStandby: ventilatorStandby,
        config: state.configReducer.config,
    };
};

const ConnectedBedCardVentilatorMonitor = connect(
    mapStateToProps, null
)(BedCardVentilatorMonitor);

const BedCardVentilatorMonitorRef = forwardRef((props, ref) =>
    <ConnectedBedCardVentilatorMonitor key={props.bedId} {...props} myForwardedRef={ref} />
);
export default BedCardVentilatorMonitorRef;